function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-176.55 -73.12)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.26458 0 0 .26458 176.55 73.12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m27.5 0c15.189 0 27.5 12.313 27.5 27.5 0 15.189-12.311 27.5-27.5 27.5s-27.5-12.311-27.5-27.5c0-15.187 12.311-27.5 27.5-27.5z",
  fill: "#22323f"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30.848 18.932h3.5441v-5.2353h-4.1662v0.0188c-5.0481 0.1788-6.0827 3.0164-6.1739 5.9968h-0.0103v2.6142h-3.4375v5.127h3.4375v13.743h5.1803v-13.743h4.2436l0.8198-5.127h-5.0617v-1.5794c0-1.0073 0.6703-1.8151 1.6243-1.8151z",
  fill: "#fff"
})));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14.552mm",
    height: "14.552mm",
    viewBox: "0 0 14.552 14.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f18d5cc5.svg";
export { ForwardRef as ReactComponent };